import { toast } from 'sonner';
import { I18N } from './i18n';
import { exportPDF, pdfName } from './pdf';
import { download } from './exporters';
import { routeLink } from './route';
import { APP_INFO } from './license';

export function shareText(t, title, address, p) {
  return [title, address && `${t.addrLabel}: ${address}`, `${t.pdfDate}: ${new Date().toLocaleDateString(t.locale)}`,
    p?.lat != null && `${t.routeBtn}: ${routeLink(p)}`, '', `${t.shareFooter} ${APP_INFO.name}`].filter((x) => x !== false && x != null).join('\n');
}

// Web Share API with file (Android share sheet: WhatsApp, E-Mail …); falls back to download
// share a finished tour: GPX + PDF (map, elevation profile, waypoints) via the phone share sheet
export async function shareTrack(tr, t, gpx, pdfBlob, base, story) {
  const files = story ? [new File([story], `${base}_Tour-Story.html`, { type: 'text/html' })] : [new File([gpx], `${base}.gpx`, { type: 'application/gpx+xml' }), new File([pdfBlob], `${base}.pdf`, { type: 'application/pdf' })];
  const text = `${tr.name}\n${t.shareFooter} ${APP_INFO.name}`;
  if (navigator.canShare?.({ files })) {
    try { await navigator.share({ files, title: tr.name, text }); } catch (e) { if (e?.name !== 'AbortError') throw e; }
    return 'shared';
  }
  files.forEach((f) => download(f, f.name));
  toast.message(t.shareFallback, { duration: 7000 });
  return 'downloaded';
}

export async function sharePdf(project, reports, lang, opts = {}) {
  const t = I18N[lang] || I18N.de;
  const blob = await exportPDF(project, reports, lang, { ...opts, blob: true });
  const name = pdfName(project, reports, opts);
  const whole = reports.length > 1 || opts.cover;
  const p = whole ? (project.lat != null ? project : reports[0]) : reports[0];
  const text = shareText(t, whole ? project.title : reports[0].title, whole ? project.address : reports[0].address, p);
  const file = new File([blob], name, { type: 'application/pdf' });
  if (navigator.canShare?.({ files: [file] })) {
    try { await navigator.share({ files: [file], title: name, text }); } catch (e) { if (e?.name !== 'AbortError') throw e; }
    return 'shared';
  }
  download(blob, name);
  try { await navigator.clipboard.writeText(text); } catch { /* ignore */ }
  toast.message(t.shareFallback, { duration: 7000 });
  return 'downloaded';
}
